import './App.css';
import { useAppViewModel } from './AppViewModel';
import Folder from './components/Folder';
import { MyEditor } from './components/MyEditor';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const { state, actions } = useAppViewModel();

  if (state.currentUser == null) {
    return <div className="App"><h2>Login from pop-up</h2></div>;
  }

  return (
    <div className="App">
      <Container fluid>
        <Row>
          <Col lg={state.expanded ? 2 : "auto"}>
            {state.expanded ? (
              <div className='folders'>
                <p>
                  {state.currentUser?.email}
                  <button onClick={() => actions.setExpanded(false)}>{"<"}</button>
                  <button onClick={() => actions.signOut()}>Sign out</button>
                </p>

                <span>Webs: </span>
                {state.webIds.map((space) => (
                  <span key={space} onClick={() => actions.setSelection(space, undefined)}>
                    {space}{" "}
                  </span>
                ))}

                <br /><br />
                <p>Selected Web: {state.webId}</p>
                <span>Users: </span>
                <br />
                {state.users.map(u => <span key={u.email}>{u.email} </span>)}

                <br /><br />
                {state.web?.rootPages?.map((pageId) => (
                  Folder(
                    state.web.pages, pageId, actions.add, (pageId) => actions.getPage(state.webId, pageId),
                    state.openPagesMap, actions.setOpenPagesMap, state.isMoving, actions.movePage
                  )
                ))}

                <button className='folders' onClick={state.isMoving ? () => actions.movePage() : () => actions.add()}>
                  {state.isMoving ? "Move to root" : "Add root page"}
                </button>

                {state.showingAddPage && (
                  <>
                    <input value={state.newPageName} onChange={(e) => actions.setNewPageName(e.target.value)} />
                    <button onClick={actions.addPage}>Add Page</button>
                  </>
                )}
              </div>
            ) : (
              <button onClick={() => actions.setExpanded(true)}>{">"}</button>
            )}
          </Col>

          <Col md={12} lg={state.expanded ? 10 : 12}>
            {state.web.pages === null ? (
              <div>
                <h1>Page not available</h1>
                <p>This page does not exist or you do not have access to it</p>
              </div>
            ) : state.currentPageData === "" ? null : (
              <MyEditor
                selectedPage={state.pageId}
                tree={state.web}
                existingPageData={state.currentPageData}
                savePage={actions.savePage}
                saveChange={actions.saveChange}
                addBlankPage={actions.addBlankPage}
                deletePage={actions.deletePage}
                setIsMoving={actions.setIsMoving}
              />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default App;